<template>
    <MainLayout>
        <div class="student-list">
            <section>
                <div class="container">
                    <ul class="nav-bar">
                        <router-link :to="{ name: 'dashboard' }">
                            <li><a><i class="fa-solid fa-house"></i></a></li>
                        </router-link>
                        <li class="active">Student Lists</li>
                    </ul>
                </div>
            </section>
            <section class="main-visual">
                <div class="container">
                    <div class="sec-visual">
                        <div class="sec-heading-action">
                            <div class="ttl">
                                <h1>Student Lists</h1>
                            </div>
                            <div class="search-toggle-wrapper">
                                <button type="button" class="btn-search-toggle" :class="{ 'active': isFilterOpen }" 
                                    @click="isFilterOpen = !isFilterOpen">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    <span>Search Filter</span>
                                    <i class="fa-solid" :class="isFilterOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                </button>
                            </div>
                        </div>
                        <transition name="fade">
                            <div class="search-form" v-show="isFilterOpen">
                                <form v-on:submit.prevent>
                                    <div class="form-group">
                                        <div class="form-input">
                                            <label> Student Name </label>
                                            <input type="text" id="c-name" v-model="name">
                                        </div>
                                        <div class="form-input">
                                            <label> Student Number </label>
                                            <input type="text" id="c-number" v-model="student_no">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-input">
                                            <label for="year">Academic Year</label>
                                            <Select2Multiple class="multi-select w-100-select" id="year"
                                                :settings={multiple:false} v-model="selectedYear" :options="academicYearArr"
                                                @change="changeEvent($event,'year')" />
                                        </div>
                                        <div class="form-input">
                                            <label for="grade" class="select-label"> Grade Name </label>
                                            <Select2Multiple class="multi-select w-100-select" id="grade"
                                                :settings="{multiple:false, placeholder:'All'}"
                                                :options="gradeArr" v-model="selectedGrade" @change="changeEvent($event, 'grade_id')" />
                                        </div>
                                        <div class="form-input">
                                            <label for="section" class="select-label"> Section </label>
                                            <Select2Multiple class="multi-select w-100-select" id="section"
                                                :settings="{multiple:false, placeholder:'All'}" v-model="selectedSection"
                                                :options="sectionArr" @change="changeEvent($event, 'section_id')" />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-input">
                                            <label> Phone Number </label>
                                            <input type="text" id="phone" v-model="phone">
                                        </div>
                                    </div>
                                    <div class="form-submit">
                                        <div class="form-input">
                                            <i class="fa-sharp fa-solid fa-rotate-right reset"></i>
                                            <input type="button" class="form-action-button form-reset" value="Reset"
                                                @click="reset()">
                                        </div>
                                        <div class="form-input">
                                            <i class="fa-regular fa-magnifying-glass search"></i>
                                            <input type="Submit" value="Search" class="form-search"
                                                @click="searchStudent()">
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </transition>

                        <!-- import -->
                        <div v-if="can('STUDENT', 'import')" class="box" v-show="!isLoading">
                            <div class="attendance-list import-form">
                                <div class="ttl">
                                    <h1>Student Data Import</h1>
                                </div>
                                <a class="btn-add" @click.prevent="downloadImportTemplate"><i
                                        class="fa-solid fa-file-arrow-down"></i>Template Download</a>
                                <div class="attendance-tbl">
                                    <table class="import-tbl">
                                        <tbody>
                                            <tr>
                                                <th class="require">Student Data</th>
                                                <td class="d-flex import-file-box">
                                                    <div class="file-input">
                                                        <input ref="fileUploader" type="file" id="student-upload"
                                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                            v-on:change="onStudentFileChange()">
                                                        <input type="text" id="txt_file_xlsx" ref="file"
                                                            v-model="studentFileName" readonly>
                                                        <div class="text-danger"
                                                            v-if="submitted && !$v.studentFile.required"> Import File is
                                                            required. </div>
                                                        <div class="text-danger" v-if="invalidFile"> File Not Support!
                                                        </div>
                                                    </div>
                                                    <a class="btn-add choose-btn" @click="chooseFile()"><i
                                                            class="fa-solid fa-file-excel"></i>Choose</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="form-submit">
                                        <div class="form-input">
                                            <a class="form-action-button btn-file-clear" @click="clearFile()"><i
                                                    class="fa-sharp fa-solid fa-rotate-right"></i>Clear</a>
                                        </div>
                                        <div class="form-input">
                                            <a class="btn-import" @click="importFile()"
                                                :class="{ btnDisabled: disabled }"><i
                                                    class="fa-solid fa-file-excel"></i>Import</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- import -->
                        <div class="box first-table" v-show="!isLoading">
                            <div class="attendance-list">
                                <div class="ttl">
                                    <h1>Active Student Lists</h1>
                                </div>
                                <!-- <a class="btn-add" @click="showCreate()"><i class="fa-solid fa-plus"></i>Add New</a> -->
                                <div>
                                    <a v-if="can('STUDENT', 'excelDownload')" @click="excelDownload(status = 'active')" class="btn-add btn-excel">Excel
                                        Download</a>
                                    <a v-if="can('STUDENT', 'setResult')" class="btn-add delete btn-excel pass-fail-btn"
                                        :class="{ btnDisabled: passFailDisable }"
                                        @click="checkPassFailValidate(search_status ? searchSelectedCb : selectedCb, 0)">Fail</a>
                                    <a v-if="can('STUDENT', 'setResult')" class="btn-add activate btn-excel pass-fail-btn"
                                        :class="{ btnDisabled: passFailDisable }"
                                        @click="checkPassFailValidate(search_status ? searchSelectedCb : selectedCb, 1)">Pass</a>
                                </div>
                                <p class="total-count" v-if="studentList.total > 0"> Total - {{ studentList.total }}
                                </p>
                                <div class="attendance-tbl">
                                    <table id="active-table">
                                        <thead>
                                            <th v-if="can('STUDENT', 'setResult')" class="stu-check">
                                                <label class="cb-label cb-header">
                                                    <input type="checkbox"
                                                        :disabled="studentList.total > 0 ? false : true"
                                                        v-model="checkAll" @click="selectAll()" />
                                                    <span class="checkmark checkmark-header"></span>
                                                </label>
                                            </th>
                                            <th style="width:65px">No</th>
                                            <th>Student Name</th>
                                            <th style="width:120px">Student Number</th>
                                            <th>Phone Number 1</th>
                                            <th class="col-acd-period">Academic Period</th>
                                            <th class="text-nowrap" style="width:130px">Class Name</th>
                                            <th class="attendance-tr" style="width:90px">Result</th>
                                            <th class="attendance-tr" style="width:400px"></th>
                                        </thead>
                                        <tbody v-if="studentList.total > 0">
                                            <tr v-for="(studentInfo, index) in studentList.data" :key="studentInfo.id"
                                                :value="studentInfo.id" :class="['row-' + index]">
                                                <td v-if="can('STUDENT', 'setResult')">
                                                    <label class="cb-label">
                                                        <input type="checkbox" name="result-cb"
                                                            :value="studentInfo.class_student_id" v-model="selectedCb"
                                                            @change='updateCheckall($event, studentInfo.class_student_id)'
                                                            v-if="!search_status">
                                                        <input type="checkbox" name="result-cb"
                                                            :value="studentInfo.class_student_id"
                                                            v-model="searchSelectedCb"
                                                            @change='updateCheckall($event, studentInfo.class_student_id)'
                                                            v-else>
                                                        <span class="checkmark checkmark-body"></span>
                                                    </label>
                                                </td>
                                                <td data-label="No">{{(studentList.current_page
                                                    -1)*(studentList.per_page) + (index + 1)}}</td>
                                                <td data-label="Student Name">{{studentInfo.name}}</td>
                                                <td data-label="Student No">{{studentInfo.c_student_no}}</td>
                                                <td data-label="Phone Number 1">{{studentInfo.student.phone1}}</td>
                                                <td data-label="Academic Period" class="col-acd-period">
                                                    <div class="period-names-wrap">{{ formatPeriodNames(studentInfo.period_names) }}</div>
                                                </td>
                                                <td data-label="Class Name">
                                                    <span style="margin-right: 5px;">{{
                                                        studentInfo.grade_result[0]?.grade }}</span>
                                                    <span v-if="studentInfo.grade_result.length > 1"
                                                        @click="toggleRow(studentInfo.grade_result, index)"
                                                        style="cursor: pointer;">
                                                        <i
                                                            :class="['fa-solid', saveIndexes.includes(index) ? 'fa-caret-up' : 'fa-caret-down']"></i>
                                                    </span>
                                                </td>
                                                <td>{{ studentInfo.grade_result[0]?.status }}</td>
                                                <td class="action-btn">
                                                    <a class="edit" v-if="can('STUDENT', 'edit')"
                                                        @click="showEdit(studentInfo.class_student_id)">Edit</a>
                                                    <a class="detail"
                                                        @click="showDetail(studentInfo.class_student_id, 'active')">Detail</a>
                                                    <a class="delete deactivate-btn" v-if="can('STUDENT', 'delete')"
                                                        @click="confirmDeactivate(studentInfo.class_student_id)">Deactivate</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="8">{{noDataMsg}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <b-modal hide-footer id="modal-1" title="Proceed to the next class?">
                                    <div class="d-flex justify-content-flex-end">
                                        <a class="btn-add activate btn-excel mb-0"
                                            @click="proceed = false; $bvModal.hide('modal-1'), setPassFail(selectedCb, passFailResult, 0, 0)"
                                            v-if="!search_status && selectedCb.length >= 1">No</a>

                                        <a class="btn-add activate btn-excel mb-0"
                                            @click="proceed = false; $bvModal.hide('modal-1'), setPassFail(searchSelectedCb, passFailResult, 0, 0)"
                                            v-if="search_status && searchSelectedCb">No</a>

                                        <a class="btn-add activate btn-excel pass-fail-btn mb-0"
                                            @click="hideModal1(), $bvModal.show('modal-2')">Yes</a>
                                    </div>
                                </b-modal>

                                <b-modal id="modal-2" hide-footer title="Select the next class to proceed.">
                                    <Select2Multiple class="multi-select w-100-select mt-0"
                                        :disabled="hasPreRegistration"
                                        :settings="{multiple:false, placeholder:'Select Academic Year' }"
                                        v-model="year_id" :options="currentAndNextYearArr"
                                        @change="getClass(year_id), changeEvent($event,'year_id')" />

                                    <div class="text-danger" v-if="requiredYear">Academic Year is required.</div>

                                    <Select2Multiple class="multi-select w-100-select mt-20"
                                        :disabled="hasPreRegistration"
                                        :settings="{multiple:false, placeholder:'Select Class' }" v-model="class_id"
                                        :options="classArr" @change="changeEvent($event,'class_id')" />

                                    <div class="text-danger" v-if="requiredClass">Class is required.</div>

                                    <div class="mt-20">
                                        <a class="btn-add activate btn-excel mb-0"
                                            @click="proceed = true; setPassFail(selectedCb, passFailResult, class_id, year_id)"
                                            v-if="!search_status && selectedCb.length >= 1">Proceed</a>

                                        <a class="btn-add activate btn-excel mb-0"
                                            @click="proceed = true; setPassFail(searchSelectedCb, passFailResult, class_id, year_id)"
                                            v-if="search_status && searchSelectedCb.length > 0">Proceed</a>

                                        <a class="btn-add btn-excel mb-0" @click="$bvModal.hide('modal-2')">Back</a>
                                    </div>

                                </b-modal>
                            </div>
                            <b-modal hide-footer id="modal-deactivate-reason" title="Confirm Student Removal" no-enforce-focus no-close-on-backdrop body-class="deactivate-reason-modal-body">
                                <p class="reason-text mb-3">Please select the reason for removing this student from the system. This will update their permanent record status.</p>
                                <div class="form-group mb-2">
                                    <input type="radio" id="deactivate-reason-transferred" name="deactivation_reason" value="transferred" v-model="deactivationReason">
                                    <label for="deactivate-reason-transferred" class="ml-2">Transferred to another school</label>
                                </div>
                                <div class="form-group mb-2">
                                    <input type="radio" id="deactivate-reason-expelled" name="deactivation_reason" value="expelled" v-model="deactivationReason">
                                    <label for="deactivate-reason-expelled" class="ml-2">Expelled (Disciplinary action)</label>
                                </div>
                                <div class="text-danger mb-2" v-if="deactivationReasonError">Please select a reason.</div>
                                <div class="d-flex gap-2 justify-content-center mt-3">
                                    <input type="button" class="form-action-button cancel" value="Cancel" @click="cancelDeactivate" />
                                    <input type="button" class="form-action-button" value="Confirm" @click="confirmDeactivationReason" />
                                </div>
                            </b-modal>
                            <b-modal hide-footer id="modal-deactivate-warning" title="Warning" no-enforce-focus no-close-on-backdrop body-class="deactivate-warning-modal-body">
                                <p class="warning-message mb-2">{{ siblingDiscountMessage }}</p>
                                <div class="d-flex gap-3 justify-content-center">
                                    <input type="button" class="form-action-button cancel" value="Cancel" @click="cancelDeactivateAfterWarning" />
                                    <input type="button" class="form-action-button" value="OK" @click="proceedWithDeactivateAfterWarning" />
                                </div>
                            </b-modal>
                            <b-modal hide-footer id="modal-final-year-warning" title="Final Year Student Warning" no-enforce-focus no-close-on-backdrop>
                                <p>This student is in a final year grade. If you proceed with passing this student, they will be marked as <strong>Graduated</strong> and will not be assigned to a new class.</p>
                                <p class="mt-10">Are you sure you want to proceed?</p>
                                <div class="mt-20 d-flex justify-content-center" style="gap: 0.5rem;">
                                    <input type="button" class="form-action-button cancel" value="Cancel" @click="$bvModal.hide('modal-final-year-warning')" />
                                    <input type="button" class="form-action-button" value="Confirm" @click="proceedFinalYearPass" />
                                </div>
                            </b-modal>
                            <advanced-laravel-vue-paginate v-if="search_status == false" class="vue-paginate"
                                :data="studentList" :onEachSide="2" :previousText="'«'" :nextText="'»'"
                                @paginateTo="handleActivePageChange" />
                            <advanced-laravel-vue-paginate v-if="search_status == true" class="vue-paginate"
                                :data="studentList" :onEachSide="2" :previousText="'«'" :nextText="'»'"
                                @paginateTo="handleActivePageChange" />
                        </div>
                        <div v-if="auth('admin').check()" class="box sec-table" v-show="!isLoading">
                            <div class="attendance-list leaved-list">
                                <div class="ttl">
                                    <h1>Inactive Student Lists</h1>
                                </div>
                                <a v-if="can('STUDENT', 'excelDownload')" @click="excelDownload(status = 'leave')" class="btn-add btn-excel">Excel Download</a>
                                <p class="total-count" v-if="leavedStudentList.total > 0"> Total - {{
                                    leavedStudentList.total }} </p>
                                <div class="attendance-tbl">
                                    <table>
                                        <thead>
                                            <th style="width:50px">No</th>
                                            <th>Student Name</th>
                                            <th style="width:160px">Status</th>
                                            <th>Class Name</th>
                                            <th class="attendance-tr" style="width:400px"></th>
                                        </thead>
                                        <tbody v-if="leavedStudentList.total > 0">
                                            <tr v-for="(studentInfo, index) in leavedStudentList.data"
                                                :key="studentInfo.id" :value="studentInfo.id">
                                                <td data-label="No">{{(leavedStudentList.current_page
                                                    -1)*(leavedStudentList.per_page) + (index + 1)}}</td>
                                                <td data-label="Student Name">{{studentInfo.name}}</td>
                                                <td data-label="Status">{{ getStatusText(studentInfo.status) }}</td>
                                                <td data-label="Class Name">{{ studentInfo.grade_sections }}</td>
                                                <td>
                                                    <a class="edit deactivate-btn" v-if="can('STUDENT', 'restore')"
                                                        @click="showRestore(studentInfo.class_student_id)">Restore</a>
                                                    <a class="detail leave-detail-btn"
                                                        @click="showDetail(studentInfo.class_student_id, 'leaved')">Detail</a>
                                                    <a class="delete" v-if="can('STUDENT', 'delete')"
                                                        @click="confirmDeleteFormerStudent(studentInfo.student_id)">Delete</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="5">{{ noDataMsg }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <advanced-laravel-vue-paginate v-if="leaved_search_status == false" class="vue-paginate"
                                :data="leavedStudentList" :onEachSide="2" :previousText="'«'" :nextText="'»'"
                                @paginateTo="handleLeavedPageChange" />

                            <advanced-laravel-vue-paginate v-if="leaved_search_status == true" class="vue-paginate"
                                :data="leavedStudentList" :onEachSide="2" :previousText="'«'" :nextText="'»'"
                                @paginateTo="handleLeavedPageChange" />
                        </div>
                    </div>
                </div>
                <div class="vld-parent">
                    <loading :active.sync="isLoading" :can-cancel="true" color="#4688d9"></loading>
                </div>
            </section>
        </div>
    </MainLayout>
</template>

<script>
import studentListController from '@/controllers/custom/student/student-list.js';

export default {
  extends: studentListController,
}
</script>

<style>
  @import '@/assets/css/attendance.css';
  @import '@/assets/plugins/css/select2.css';
  @import '@/assets/plugins/css/flatpickr.min.css';
  @import '@/assets/css/modal.css';
  @import '@/assets/css/custom/student.css';
  @import '@/assets/css/custom/student-status-box.css';
</style>
